import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getFactorsRequest: ['values'],
  getFactorsSuccess: ['data'],
  getFactorsFailure: [],
});

export const FactorsTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
  error: false,
});

/* Reducers */

const getFactorsRequest = (state) => state.merge({
  ...state,
  loading: true,
});

const getFactorsSuccess = (state, { data }) => state.merge({
  data,
  loading: false,
  error: false,
});

const getFactorsFailure = (state) => state.merge({
  ...state,
  error: true,
  loading: false,
});

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FACTORS_REQUEST]: getFactorsRequest,
  [Types.GET_FACTORS_SUCCESS]: getFactorsSuccess,
  [Types.GET_FACTORS_FAILURE]: getFactorsFailure,
});
